export type DirectorAspectRatio = '16:9' | '9:16' | '1:1' | string;
export type DirectorImageSize = '1024x1024' | '1792x1024' | '1024x1792';

export const DIRECTOR_IMAGE_SIZE_OPTIONS: Array<{
  value: DirectorImageSize;
  label: '1:1' | '16:9' | '9:16';
}> = [
  { value: '1024x1024', label: '1:1' },
  { value: '1792x1024', label: '16:9' },
  { value: '1024x1792', label: '9:16' },
];

export function getDefaultDirectorImageSize(
  aspectRatio?: DirectorAspectRatio
): DirectorImageSize {
  if (aspectRatio === '16:9') return '1792x1024';
  if (aspectRatio === '9:16') return '1024x1792';
  return '1024x1024';
}
